import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-476a69e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "general" }
const _hoisted_4 = {
  key: 0,
  class: "modal"
}
const _hoisted_5 = { class: "contenedor" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Filtros", -1))
const _hoisted_7 = { class: "contenido" }
const _hoisted_8 = { class: "contenido" }
const _hoisted_9 = { class: "grid" }
const _hoisted_10 = {
  style: {"margin-top":"40px"},
  class: "empleados"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Empleados ")
const _hoisted_12 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_ListadoComponent = _resolveComponent("ListadoComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        ($data.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("img", {
                class: "img",
                src: 'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
              }, null, 8, _hoisted_2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Navbar),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      ($data.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMethod())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Filters, {
                    filterEmpleados: $options.filterEmpleados,
                    search: $options.search,
                    filteredEmpleados: _ctx.filteredEmpleados
                  }, null, 8, ["filterEmpleados", "search", "filteredEmpleados"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h4", null, [
            _hoisted_11,
            _createElementVNode("i", {
              style: {"cursor":"pointer"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push(`/empleados/new`))),
              class: "fas fa-plus",
              _mstvisible: "2"
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createVNode(_component_ListadoComponent, { empleados: $data.empleados }, null, 8, ["empleados"]), [
              [_vShow, !$data.cargando]
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, !$data.cargando]
    ])
  ]))
}